import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  effect,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import {StandardDfpBannerItem} from '../../../classes/standard-dfp-banner-item';
import {BannerHostDirective} from '../../../directives/banner-host.directive';
import {ToolsService} from '../../../services/tools.service';
import {DfpBannerComponentType} from '../../../types/DfpBannerComponentType';
import {DfpBannerData} from '../../../types/DfpBannerData';
import {StandardDfpBannerComponent} from '../standard-dfp-banner/standard-dfp-banner.component';
import {StorageService} from '../../../services/storage.service';
import {SessionStorageEnum} from '../../../enums/SessionStorageEnum';
import {AdsStateService} from '../../../services/ads-state.service';
import {DfpStateData} from '../../../types/DfpStateData';
import {ElementToggleEnum} from '../../../enums/CssClassEnums';

@Component({
  selector: 'app-standard-dfp-banner-loader',
  templateUrl: './standard-dfp-banner-loader.component.html',
  styleUrls: ['./standard-dfp-banner-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StandardDfpBannerLoaderComponent implements OnInit {
  @Input() unitName: string;
  @Input() size: googletag.GeneralSize;
  @Input() bannerGroup: string;
  @Input() isFluid: boolean;
  @Input() showAdLabel: boolean = false;
  @Input() reloadCallback: Function;
  @ViewChild(BannerHostDirective, {static: true})
  bannerHost: BannerHostDirective;

  public careproviderUnitTypeId: number;
  public careServiceTypeId: number;
  public symptomId: number;
  public placeId: number;
  public isCustomer: string;
  public pageModule: string;

  private adsStateService = inject(AdsStateService);
  private adsState = this.adsStateService.state;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private tools: ToolsService,
    private storage: StorageService,
    private _change: ChangeDetectorRef,
  ) {
    effect(
      () => {
        if (this.adsState()) {
          this.processState(this.adsState());
        }
      },
      {allowSignalWrites: true},
    );
  }

  ngOnInit(): void {
    if (!this.tools.isNil(this.reloadCallback)) {
      this.reloadCallback(ElementToggleEnum.HIDDEN);
    }
  }

  private processState(result: DfpStateData): void {
    this.careproviderUnitTypeId = result.careproviderUnitTypeId;
    this.careServiceTypeId = result.careServiceTypeId;
    this.symptomId = result.symptomId;
    this.placeId = result.placeId;
    this.isCustomer = result.isCustomer;
    this.pageModule = result.pageModule;
    this.loadBanner();
  }

  private loadBanner(): void {
    const viewContainerRef = this.bannerHost.viewContainerRef;
    viewContainerRef.clear();

    if (this.isClosed() === false) {
      const bannerData: DfpBannerData = {
        unitName: this.unitName,
        size: this.size,
        careproviderUnitTypeId: this.careproviderUnitTypeId,
        careServiceTypeId: this.careServiceTypeId,
        symptomId: this.symptomId,
        placeId: this.placeId,
        bannerGroup: this.bannerGroup,
        isCustomer: this.isCustomer,
        pageModule: this.pageModule,
        isFluid: this.isFluid,
        showAdLabel: this.showAdLabel,
        reloadCallback: this.reloadCallback,
      };
      const bannerItem = new StandardDfpBannerItem(StandardDfpBannerComponent, bannerData);
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(bannerItem.component);
      const componentRef = viewContainerRef.createComponent(componentFactory);
      (componentRef.instance as DfpBannerComponentType).data = bannerItem.data;
      this._change.markForCheck();
    }
  }

  private isClosed(): boolean {
    const storageState = this.storage.read(SessionStorageEnum.CLOSEABLEAD);
    if (!this.tools.isNil(storageState) && !this.tools.isNil(this.bannerGroup)) {
      return storageState.indexOf(this.bannerGroup) >= 0;
    } else {
      return false;
    }
  }
}
